import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bs-container" }
const _hoisted_2 = { class: "pp-ticket-check-results-summary bs-row" }
const _hoisted_3 = { class: "pp-ticket-check-results-summary__section c-12 c-sm-6 c-md-5 bs-offset-md-1 c-lg-4 c-xl-5" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { class: "pp-ticket-check-results-summary__tooltip-text" }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { class: "pp-ticket-check-results-summary__banners c-12 c-sm-6 c-md-5 bs-offset-md-1 c-lg-6 bs-offset-lg-0 c-xl-5" }

import { computed, onMounted } from "vue";
import DsButton from "@sazka/design-system/src/button/ds-button.vue";
import DsPromoBannerNew from "@sazka/design-system/src/promo-banner/ds-promo-banner-new.vue";
import DsSmileStatic from "@sazka/design-system/src/smiles/ds-smile-static.vue";
import DsTooltip from "@sazka/design-system/src/tooltip/ds-tooltip.vue";
import { DsPromoBannerNewDto } from "@sazka/design-system/src/promo-banner/ds-promo-banner-new";
import {
    DsSmileStaticFacePosition,
    DsSmileStaticFaceType,
} from "@sazka/design-system/src/smiles/ds-smile-static-types";
import { StringUtils } from "@sazka/utils/string-utils";
import { AnalyticsPromo } from "@/shared/utils/analytics/analytics-promo";
import { ProductPageAnalytics } from "../../analytics/analytics-product-page";
import { usePpTicketCheck } from "../../composables/use-ticket-check";


export default /*@__PURE__*/_defineComponent({
  __name: 'pp-ticket-check-results-summary',
  setup(__props) {

const { ticketCheckResult } = usePpTicketCheck();

const formattedText = computed(() => {
    return ticketCheckResult.value.resultsTexts.text
        .replace(
            "{{AMOUNT}}",
            `<span class="pp-ticket-check-results-summary__text--amount">${StringUtils.formatCurrency(
                ticketCheckResult.value.winAmount
            )}</span>`
        )
        .replace(/\n/g, "<br>");
});

const faceAttributes = computed(() => {
    return ticketCheckResult.value.winAmount
        ? { type: DsSmileStaticFaceType.Stars, position: DsSmileStaticFacePosition.CenterDown }
        : { type: DsSmileStaticFaceType.Sad, position: DsSmileStaticFacePosition.RightDown };
});

onMounted(() => {
    if (ticketCheckResult.value.resultsTexts.tooltipText) {
        const popperElement = document.querySelector<HTMLDivElement>(
            ".pp-ticket-check-results-summary__tooltip .popper"
        );
        if (popperElement) {
            popperElement.style.display = "block";
        }
    }
});

// Analytics
const getBannerPosition = (idx: number) => {
    if (idx === 0) {
        return "top";
    }
    if (idx === ticketCheckResult.value.banners.length - 1) {
        return "bottom";
    }
    return "middle";
};
ticketCheckResult.value.banners.forEach((banner, idx) => {
    const promo: AnalyticsPromo = {
        id: banner.codeName,
        name: banner.codeName,
        creative: StringUtils.sanitizeString(banner.headline),
        position: getBannerPosition(idx),
    };

    ProductPageAnalytics.pushTicketCheckBannerImpress(promo);
});

const onBannerClick = (banner: DsPromoBannerNewDto, idx: number) => {
    const promo = {
        id: banner.codeName,
        name: banner.codeName,
        creative: StringUtils.sanitizeString(banner.headline),
        position: getBannerPosition(idx),
    };

    ProductPageAnalytics.pushTicketCheckBannerClick(promo);
};

const onButtonClick = (buttonText: string) => {
    ProductPageAnalytics.pushTicketCheckButtonClick(buttonText);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(DsSmileStatic, {
          "face-type": faceAttributes.value.type,
          "face-position": faceAttributes.value.position,
          "with-shadow": true,
          "shadow-color": "black",
          class: "pp-ticket-check-results-summary__kulicnik",
          width: 120,
          height: 120
        }, null, 8, ["face-type", "face-position"]),
        _createElementVNode("p", {
          innerHTML: formattedText.value,
          class: "pp-ticket-check-results-summary__text"
        }, null, 8, _hoisted_4),
        _createVNode(DsButton, {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (onButtonClick(_unref(ticketCheckResult).resultsTexts.buttonText))),
          href: _unref(ticketCheckResult).resultsTexts.buttonLink
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(ticketCheckResult).resultsTexts.buttonText), 1)
          ]),
          _: 1
        }, 8, ["href"]),
        (_unref(ticketCheckResult).resultsTexts.tooltipText)
          ? (_openBlock(), _createBlock(DsTooltip, {
              key: 0,
              "has-trigger": false,
              placement: "bottom",
              class: "pp-ticket-check-results-summary__tooltip",
              "z-index": 1
            }, {
              default: _withCtx(() => [
                _createElementVNode("p", _hoisted_5, [
                  _createElementVNode("span", {
                    innerHTML: _unref(ticketCheckResult).resultsTexts.tooltipText
                  }, null, 8, _hoisted_6)
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_7, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(ticketCheckResult).banners, (banner, idx) => {
          return (_openBlock(), _createBlock(DsPromoBannerNew, {
            key: banner.codeName,
            banner: banner,
            onClick: ($event: any) => (onBannerClick(banner, idx))
          }, null, 8, ["banner", "onClick"]))
        }), 128))
      ])
    ])
  ]))
}
}

})